import { render, staticRenderFns } from "./CandidateFullTask.vue?vue&type=template&id=5f3862c8"
import script from "./CandidateFullTask.vue?vue&type=script&lang=js"
export * from "./CandidateFullTask.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports